import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';
import { components } from '@doltech/dto';

export const getUserDictationById = (userDictationId: string) => {
  return apis.onlineTest.get<components['schemas']['UserDictationDTO']>(
    apiUrls.onlineTest.USER_DICTATION_BY_ID,
    { id: userDictationId }
  );
};

export const saveUserDictationProgress = (
  userDictationId: string,
  payload: components['schemas']['UserSubmitDictationDTO']
) => {
  return apis.onlineTest.put(apiUrls.onlineTest.USER_DICTATION_BY_ID, payload, {
    params: { id: userDictationId },
  });
};

export const submitUserDictation = (
  userDictationId: string,
  payload: components['schemas']['UserSubmitDictationDTO']
) => {
  return apis.onlineTest.put(apiUrls.onlineTest.SUBMIT_USER_DICTATION, payload, {
    params: { id: userDictationId },
  });
};
